import React from "react";
import {
  IonContent,
  IonRow,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  useIonAlert
} from "@ionic/react";

import { handleOtpBackButton, handleOtpSubmission } from "../handler";
import { useRecoilState,useSetRecoilState } from "recoil";
import { userInput, userAuthDetail } from "../../../store/atoms/userDetailAtom";
import { useHistory } from 'react-router-dom';

import "../../../styles/UserSignInComponent.css";

function OtpVerification(props) {
  const [present] = useIonAlert()
  const history = useHistory()
  const [userInputState, setUserInputState] = useRecoilState(userInput);
  const setUserAuth = useSetRecoilState(userAuthDetail);

  return (
    <>
      <IonContent className="Loginpage">
        <IonContent>
          <IonRow className="image-bg">
            <IonCard>
              <IonCardHeader>
                <div>
                  <button
                    className="back-login"
                    onClick={() => {
                      handleOtpBackButton(props.setDisplayOtpVerification);
                    }}
                  >
                    <img src="img/back.svg" />{" "}
                  </button>
                </div>
                <img src="img/logo.png" className="logo-img" alt="logo"></img>
                <IonCardTitle>
                  <h1>Verify Login</h1>
                </IonCardTitle>
                <p>Enter the OTP that will be sent to your {userInputState.userSelectedInput === 'email' ? 'email address' : 'mobile number'}</p>
              </IonCardHeader>
              <IonCardContent className="otp-label">
                <div className="custom-label">
                  <ion-label>OTP</ion-label>
                  <input
                    type="text"
                    className="custom-input-verify"
                    placeholder=""
                    maxLength="6"
                    onChange={async(e)=>{
                      let response = await handleOtpSubmission(e.target.value, userInputState,setUserInputState, setUserAuth, history)
                      if (!response.status) {
                        present({
                          message: response.error.msg,
                          buttons: [
                                  'Ok'
                          ],
                      })
                      }
                    }}
                  />
                </div>
                <a className="otp-link">Didn’t receive OTP?</a>
              </IonCardContent>
            </IonCard>
          </IonRow>
        </IonContent>
      </IonContent>
    </>
  );
}

export default OtpVerification;
